/*! @azure/msal-browser v4.13.2 2025-06-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.13.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
